import { render, staticRenderFns } from "./Strength.vue?vue&type=template&id=4a9e7a4d&scoped=true&"
import script from "./Strength.vue?vue&type=script&lang=js&"
export * from "./Strength.vue?vue&type=script&lang=js&"
import style0 from "./Strength.vue?vue&type=style&index=0&id=4a9e7a4d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9e7a4d",
  null
  
)

export default component.exports